export default __webpack_public_path__ + "static/media/top1-medal-icon.38668b3d.svg";